/**
 * Part-stage dates — date-only milestones for stages 6, 7, 8, 10, 12, 14, 15, 16, 17, 18.
 *
 * Stage 10 (Re-inspection Offered) is included here even though it's part of the
 * inspection cycle, because it's date-only (no outcome).
 *
 * Stages 9, 11, 13 are outcome-bearing and live in `inspection_events` — see
 * inspection-event.ts.
 *
 * Constraint: unique (project_item_id, stage_number).
 */

import { Type, type Static } from '@sinclair/typebox';
import { IsoDateSchema, RowVersionField, TimestampFields, UuidSchema } from './common.js';

// Stage numbers that this table backs (date-only, single-instance per part)
export const PART_STAGE_DATE_STAGE_NUMBERS = [6, 7, 8, 10, 12, 14, 15, 16, 17, 18] as const;
export type PartStageDateStageNumber = (typeof PART_STAGE_DATE_STAGE_NUMBERS)[number];

export const PartStageDateSchema = Type.Object({
  id: UuidSchema,
  projectItemId: UuidSchema,
  stageNumber: Type.Union(PART_STAGE_DATE_STAGE_NUMBERS.map((n) => Type.Literal(n))),
  completedDate: IsoDateSchema,
  recordedByUserId: UuidSchema,
  recordedAt: Type.String({ format: 'date-time' }),
  ...TimestampFields,
  ...RowVersionField,
});
export type PartStageDate = Static<typeof PartStageDateSchema>;

// ---------------------------------------------------------------------------
// Set / clear a stage date
// ---------------------------------------------------------------------------

export const PartStageDateUpsertSchema = Type.Object({
  stageNumber: Type.Union(PART_STAGE_DATE_STAGE_NUMBERS.map((n) => Type.Literal(n))),
  completedDate: IsoDateSchema,
});
export type PartStageDateUpsert = Static<typeof PartStageDateUpsertSchema>;
